import "./FacebookOauthButton.css";

type FacebookOauthButton = {
  id: string;
  isValid: boolean;
  isSubmitting: boolean;
  testLabel?: string;
};

// The colors within this component shall not be changed as they were obtained using  facebook branding guidelines.

const FacebookOauthButton = ({ id, isValid, isSubmitting, testLabel = "submit-button" }: FacebookOauthButton) => {
  return (
    <div className="fb_login_button_container fb-login-button" dir="auto">
      <button
        className="fb-button-main-element abstraction_fb_main_element"
        aria-label="Continue with Facebook"
        disabled={isSubmitting || !isValid}
        data-testid={testLabel}
        id={id}
      >
        <span className="fb_button_label_element fb_button_label">
          <svg
            viewBox="0 0 213 213"
            preserveAspectRatio="xMinYMin"
            className="fb_button_svg_logo login_fb_logo single_button_svg_logo"
          >
            <path
              d="M90,212v-75h-27v-31h27v-25q0,-40 40,-40q15,0 24,2v26h-14q-16,0 -16,16v21h30l-5,31h-27v75a106 106,0,1,0,-32 0"
              // I could not find this class on the document
              className="f_logo_circle"
              fill="white"
            ></path>
            <path
              d="M90,212v-75h-27v-31h27v-25q0,-40 40,-40q15,0 24,2v26h-14q-16,0 -16,16v21h30l-5,31h-27v75a106 106,1,0,1,-32 0"
              className="f_logo_f"
              fill="white"
            ></path>
          </svg>
          <span>Continue with Facebook</span>
        </span>
      </button>
    </div>
  );
};

export { FacebookOauthButton };
